import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import {
  ThunderboltOutlined,
  FundProjectionScreenOutlined,
  ClusterOutlined,
  InboxOutlined,
  AppstoreOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo.png';

const { Sider, Content } = Layout;

export default function BessLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: '/bess-sizing', icon: <FundProjectionScreenOutlined />, label: 'BESS Sizing Simulation' },
    { key: '/hybrid-bess', icon: <ClusterOutlined />, label: 'Hybrid BESS Solar Simulation' },
    { key: '/hybrid-bess-wind', icon: <ClusterOutlined />, label: 'Solar + Wind + Bess' },
    { key: '/bess-container', icon: <InboxOutlined />, label: 'BESS Container' },
    { key: '/pcs', icon: <ThunderboltOutlined />, label: 'Power Conversion System' },
  ];

  const selectedKey = menuItems.find(item =>
    location.pathname === item.key || location.pathname.startsWith(`${item.key}/`)
  )?.key || location.pathname;


  return (
    <Layout style={{ minHeight: '100vh' }}>
      <style>{`
        .ant-menu-item .ant-menu-title-content {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: unset !important;
        }
      `}</style>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={270}
        theme="light"
        style={{
          borderRight: '1px solid #e2e8f0',
          position: 'sticky',
          top: 0,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            padding: collapsed ? '16px 8px' : 16,
            textAlign: 'center',
            borderBottom: '1px solid #e2e8f0',
            transition: 'all 0.2s',
          }}
        >
          <img
            src={logo}
            alt="Apraava"
            style={{
              height: collapsed ? 20 : 28,
              width: 'auto',
              maxWidth: '100%',
              transition: 'all 0.2s',
            }}
          />
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
            style={{ border: 'none', fontSize: 14 }}
          />
        </div>
        <div style={{ padding: 12, borderTop: '1px solid #e2e8f0' }}>
          <Button
            icon={<AppstoreOutlined />}
            onClick={() => navigate('/app-selection')}
            block
            style={{ fontSize: 14, marginBottom: 8 }}
          >
            {!collapsed && 'Switch App'}
          </Button>
          <Button
            icon={<LogoutOutlined />}
            onClick={logout}
            block
            danger
            ghost
            style={{ fontSize: 14 }}
          >
            {!collapsed && 'Logout'}
          </Button>
        </div>
      </Sider>

      <Layout style={{ background: '#fff' }}>
        <Content className="bess-layout-content" style={{ margin: 0, padding: 0, background: '#fff', minHeight: '100vh' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
